export * from './modal.component';

